export const GAME_RESULT = {
  IN_PROGRESS: " ",
  LOST: "Lost",
  WON: "Won"
};
export const MAX_WRONG_GUESSES = 7;
export const PROGRAMING_LANGS = [
  "c",
  "csharp",
  "css",
  "dart",
  "delphi",
  "elixir",
  "erlang",
  "fortran",
  "golang",
  "groovy",
  "haskell",
  "html",
  "java",
  "javascript",
  "kotlin",
  "matlab",
  "objectivec",
  "perl",
  "php",
  "python",
  "r",
  "ruby",
  "rust",
  "scala",
  "sql",
  "swift",
  "typescript"
];

export const DATABASES = [
  "oracle",
  "mysql",
  "mssql",
  "postgresql",
  "mongodb",
  "ibmdb2",
  "redis",
  "elasticsearch",
  "sqlite",
  "msaccess",
  "cassandra",
  "mariadb",
  "splunk",
  "hive",
  "dynamodb",
  "teradata",
  "bigquery",
  "couchbase",
  "cosmosdb",
  "redshift",
  "prometheus",
  "ingres",
  "ignite",
  "pouchdb",
  "phoenix",
  "openbase"
];
